import React, { PureComponent, useEffect } from "react";
import withSizes from "react-sizes";
import { useDispatch, useSelector } from 'react-redux';

import { Button } from '../../components';
import style from './Section.module.scss';
import { career as careerFallback } from '../../api/data';
import { loadCareerData } from '../../store/slices/career';

function CareerContent({ isMobile, title, content, locale }) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (locale) dispatch(loadCareerData(locale));
  }, [dispatch, locale]);

  const { data } = useSelector(state => state.career);

  // Prefer explicit props (e.g. Home fixture) over CMS so default layout stays intact.
  const mainTitle = title || (data && data.title) || careerFallback.title;
  const description = content || (data && data.description) || careerFallback.content;
  const linkButton = (data && data.linkButton && data.linkButton.label) || 'Send Enquiry';

  return (
    <section className={`${style.section} ${style[`section--black`]}`}>
      <div className={style.career__inner}>
        <div className={`${style.section__left} ${style[`career-left`]}`}>
          <h1 className={style.career__title}>{mainTitle}</h1>
        </div>
        <div className={`${style.section__right} ${style[`career-right`]}`}>
          <p className={style.career__caption}>{description}</p>
          <div className={style.button__panel}>
            <Button type="redirect" full={isMobile} buttonName={linkButton} link={`/${locale}/contact`} />
          </div>
        </div>
      </div>
    </section>
  );
}

class SectionCareer extends PureComponent {
  render() {
    const { isMobile, title, content, locale } = this.props;
    return (
      <CareerContent
        isMobile={isMobile}
        title={title}
        content={content}
        locale={locale}
      />
    );
  }
}

const mapStateToProps = ({ width }) => ({
  isMobile: width <= 500
});

export default withSizes(mapStateToProps)(SectionCareer);
